import { useCallback, useEffect, useState } from "react";
import { fetchCart } from "@/services/api/common";
import { getCartRequestParams } from "@/utils/cartAuth";
import { normalizeCartResponse } from "@/utils/cartHelpers";

export const CART_UPDATED_EVENT = "cart:updated";

export function notifyCartUpdated() {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(CART_UPDATED_EVENT));
  }
}

export default function useCartItemCount() {
  const [count, setCount] = useState(0);

  const refresh = useCallback(() => {
    return fetchCart(getCartRequestParams())
      .then((response) => {
        const normalized = normalizeCartResponse(response);
        setCount(normalized.items.length);
      })
      .catch(() => {
        setCount(0);
      });
  }, []);

  useEffect(() => {
    refresh();

    const onFocus = () => refresh();
    const onCartUpdated = () => refresh();

    window.addEventListener("focus", onFocus);
    window.addEventListener(CART_UPDATED_EVENT, onCartUpdated);

    return () => {
      window.removeEventListener("focus", onFocus);
      window.removeEventListener(CART_UPDATED_EVENT, onCartUpdated);
    };
  }, [refresh]);

  return count;
}
